/* ============================================================
   NOCTURNAL — LP „2 Masken + Ohrstöpsel geschenkt“ · Extras
   Einblenden beim Scrollen, Querschnitt, Geräusch-Demo,
   Schlaf-Check und Bewertungs-Karussell. Kaufen läuft über
   window.MGK aus mg-kauf.js — hier gibt es keine zweite Kauflogik.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var leise = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var D = window.MG || {};
  function K() { return window.MGK || {}; }

  /* --------------------------------------------------------
     1 — Einblenden. Lebenszeichen an das Sicherheitsnetz im <head>.
     -------------------------------------------------------- */
  window.MGlebt = true;
  var rv = $$('.rv');
  if (leise || !('IntersectionObserver' in window)) {
    rv.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    rv.forEach(function (el) { io.observe(el); });
  }

  /* Sterne springen ein, sobald die Zeile im Bild ist (Hero sofort). */
  var sterne = $$('.sterne__s');
  if (leise || !('IntersectionObserver' in window)) {
    sterne.forEach(function (s) { s.classList.add('an'); });
  } else {
    var ioS = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('an'); ioS.unobserve(e.target); } });
    }, { threshold: 0.6 });
    sterne.forEach(function (s) { ioS.observe(s); });
  }

  /* Österreich-Zusatz: Liquid kennt das Land des Marktes. Steht dort
     Deutschland, der Besucher sitzt aber in Österreich, hilft die
     Zeitzone des Geräts weiter. */
  var heimat = $('#heimat');
  if (heimat && heimat.hidden) {
    try {
      if ((Intl.DateTimeFormat().resolvedOptions().timeZone || '') === 'Europe/Vienna') { heimat.hidden = false; }
    } catch (e) { /* ohne Intl bleibt die Zeile aus */ }
  }

  /* Innenansicht folgt der Farbe von Maske 1. */
  document.addEventListener('mg:auswahl', function (e) {
    var img = $('#innen-img'), b = D.maske && D.maske.bilder[e.detail.m1];
    if (img && b && b.innen && img.getAttribute('src') !== b.innen) { img.src = b.innen; }
  });

  /* --------------------------------------------------------
     2 — Querschnitt. Startet auf "flach" und kippt einmal von
         selbst auf "3D", sobald er im Bild ist — danach nur noch
         auf Knopfdruck.
     -------------------------------------------------------- */
  var bF = $('#cut-flat'), bC = $('#cut-contour');
  if (bF && bC) {
    var gF = $('#g-flat'), gC = $('#g-contour'), press = $('#press'), luft = $('#airpuff');
    var r1 = $('#r1'), r2 = $('#r2'), r3 = $('#r3'), cap = $('#cut-cap'), angefasst = false;
    var TXT = {
      flach: 'Flache Masken liegen direkt auf den Lidern. Auf der Seite drückt das Kopfgewicht mit — und an der Nase bleibt ein Spalt.',
      kontur: 'Die 3D-Kontur stützt sich auf Stirn, Nasenrücken und Wange. Über den Augen bleibt Luft, an der Nase dichtet sie ab.'
    };
    var cut = function (k) {
      gF.style.opacity = k ? '0' : '1';
      gC.style.opacity = k ? '1' : '0';
      if (press) { press.style.opacity = k ? '0' : '1'; }
      if (luft) { luft.style.opacity = k ? '1' : '0'; }
      r1.textContent = k ? 'Keiner' : 'Dauerhaft';
      r2.textContent = k ? 'Frei' : 'Kaum möglich';
      r3.textContent = k ? 'Abgedichtet' : 'Kommt durch';
      r1.style.color = r2.style.color = r3.style.color = k ? '#6FD3A6' : '#E8836B';
      cap.textContent = k ? TXT.kontur : TXT.flach;
      bF.setAttribute('aria-pressed', String(!k));
      bC.setAttribute('aria-pressed', String(k));
    };
    bF.addEventListener('click', function () { angefasst = true; cut(false); });
    bC.addEventListener('click', function () { angefasst = true; cut(true); });
    cut(false);
    var stage = $('.cut__stage');
    if (!leise && stage && 'IntersectionObserver' in window) {
      var ioC = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) { return; }
        ioC.disconnect();
        setTimeout(function () { if (!angefasst) { cut(true); } }, 1100);
      }, { threshold: 0.55 });
      ioC.observe(stage);
    }
  }

  /* --------------------------------------------------------
     3 — Geräusch-Demo
     ------------------------------------------------------------
     Schnarchen und Straßenlärm entstehen im Browser (Web Audio),
     einmal vorberechnet und dann in Schleife — keine Tondatei,
     keine Lizenzfrage. "Mit Ohrstöpseln" schiebt einen Tiefpass
     davor und nimmt Pegel weg. Das ist eine SIMULATION und steht so
     auf der Seite; einen gemessenen Dämpfungswert gibt es für die
     Ohrstöpsel nicht, also nennt die Seite auch keinen.
     Ton erst nach Antippen (Autoplay-Regeln), Stopp nach 45 s,
     beim Wegscrollen und wenn der Tab in den Hintergrund geht.
     -------------------------------------------------------- */
  var demo = $('#demo');
  if (demo) {
    var AC = window.AudioContext || window.webkitAudioContext;
    var play = $('#demo-play'), playT = $('#demo-play-t'), schalter = $('#demo-plugs'), bars = $$('.demo__viz i', demo);
    var ctx = null, filt = null, amp = null, ana = null, daten = null, quelleNode = null;
    var puffer = {}, quelle = 'schnarchen', laeuft = false, stopT = null, raf = 0, tippGezeigt = false;

    var ruhe = function () {
      bars.forEach(function (b, i) { b.style.transform = 'scaleY(' + (0.08 + 0.05 * Math.abs(Math.sin(i * 0.7))).toFixed(3) + ')'; });
    };
    ruhe();
    if (!AC) { play.disabled = true; playT.textContent = 'Ton nicht verfügbar'; }

    var koeff = function (fc, sr) { return 1 - Math.exp(-2 * Math.PI * fc / sr); };
    var normal = function (d, ziel) {
      var m = 0, i;
      for (i = 0; i < d.length; i++) { var a = Math.abs(d[i]); if (a > m) { m = a; } }
      if (m > 0) { for (i = 0; i < d.length; i++) { d[i] = d[i] / m * ziel; } }
    };
    var fenster = function (t, a, b, auf, ab) {
      if (t < a || t > b) { return 0; }
      if (t < a + auf) { return (t - a) / auf; }
      if (t > b - ab) { return (b - t) / ab; }
      return 1;
    };

    /* Schnarchen: das Gaumensegel flattert mit rund 30–40 Hz. Daraus
       Pulse, die gefiltertes Rauschen und einen tiefen Rachenton
       schlagen; Einatmen laut, Ausatmen leise, dann Pause. */
    var schnarchen = function () {
      var sr = ctx.sampleRate, dauer = 8.6, n = Math.floor(sr * dauer);
      var buf = ctx.createBuffer(1, n, sr), d = buf.getChannelData(0);
      var c1 = koeff(650, sr), c2 = koeff(260, sr), c3 = koeff(900, sr);
      var lp1 = 0, lp2 = 0, lpA = 0, ph = 0, ton = 0, zyk = 4.3;
      for (var i = 0; i < n; i++) {
        var t = i / sr, tz = t % zyk, nr = Math.floor(t / zyk);
        var ein = fenster(tz, 0.1, 1.75, 0.3, 0.4) * (0.75 + 0.25 * Math.min(1, tz / 1.6));
        var aus = fenster(tz, 2.05, 3.25, 0.35, 0.6);
        var f0 = (nr % 2 ? 31 : 36) + 4 * Math.sin(2 * Math.PI * 0.7 * t);
        ph += f0 / sr; if (ph >= 1) { ph -= 1; }
        var puls = Math.pow(Math.max(0, Math.sin(Math.PI * ph)), 8);
        var w = Math.random() * 2 - 1;
        lp1 += c1 * (w - lp1);
        lp2 += c2 * (lp1 - lp2);
        lpA += c3 * (w - lpA);
        ton += 2 * Math.PI * (98 + 10 * puls) / sr;
        var roh = (lp2 * 7 + Math.sin(ton) * 0.28) * (0.18 + 1.25 * puls);
        d[i] = roh * ein + lpA * 0.9 * aus * 0.22;
      }
      normal(d, 0.9);
      return buf;
    };

    /* Straße: tiefes Grundrauschen plus drei vorbeifahrende Autos —
       Reifenrauschen und Motorton mit leichtem Doppler-Abfall. */
    var strasse = function () {
      var sr = ctx.sampleRate, dauer = 12, n = Math.floor(sr * dauer);
      var buf = ctx.createBuffer(1, n, sr), d = buf.getChannelData(0);
      var autos = [{ t: 1.9, w: 1.0, f: 86, l: 1 }, { t: 6.6, w: 0.75, f: 112, l: 0.75 }, { t: 10.2, w: 1.3, f: 70, l: 0.6 }];
      var ph = [0, 0, 0], braun = 0, lpR = 0, lpM = 0, cR = koeff(1100, sr), cM = koeff(320, sr);
      for (var i = 0; i < n; i++) {
        var t = i / sr, w = Math.random() * 2 - 1;
        braun = (braun + 0.02 * w) / 1.02;
        lpR += cR * (w - lpR);
        var s = braun * 2.6 * (0.85 + 0.15 * Math.sin(2 * Math.PI * 0.11 * t)), motor = 0;
        for (var k = 0; k < autos.length; k++) {
          var a = autos[k], x = (t - a.t) / a.w, env = a.l / (1 + x * x * 2.2);
          var f = a.f * (1 + 0.08 * Math.tanh(-x * 1.4));
          ph[k] += f / sr; if (ph[k] >= 1) { ph[k] -= 1; }
          s += lpR * 1.1 * env;
          motor += (2 * ph[k] - 1) * env * 0.5;
        }
        lpM += cM * (motor - lpM);
        d[i] = s + lpM * 1.4;
      }
      var rand = Math.floor(sr * 0.08);
      for (var j = 0; j < rand; j++) { d[j] *= j / rand; d[n - 1 - j] *= j / rand; }
      normal(d, 0.85);
      return buf;
    };

    var aufbauen = function () {
      ctx = new AC();
      filt = ctx.createBiquadFilter(); filt.type = 'lowpass'; filt.frequency.value = 16000; filt.Q.value = 0.5;
      amp = ctx.createGain(); amp.gain.value = 0;
      ana = ctx.createAnalyser(); ana.fftSize = 256; ana.smoothingTimeConstant = 0.78;
      filt.connect(amp); amp.connect(ana); ana.connect(ctx.destination);
      daten = new Uint8Array(ana.frequencyBinCount);
    };
    var puff = function (art) {
      if (!puffer[art]) { puffer[art] = art === 'strasse' ? strasse() : schnarchen(); }
      return puffer[art];
    };
    var pegel = function (tau) {
      if (!ctx) { return; }
      var gedaempft = schalter.checked, t = ctx.currentTime, voll = quelle === 'strasse' ? 0.55 : 0.75;
      filt.frequency.setTargetAtTime(gedaempft ? 380 : 16000, t, tau);
      amp.gain.setTargetAtTime(laeuft ? (gedaempft ? voll * 0.28 : voll) : 0, t, tau);
    };
    var malen = function () {
      if (!laeuft) { return; }
      ana.getByteFrequencyData(daten);
      var n = bars.length;
      for (var i = 0; i < n; i++) {
        /* Logarithmisch verteilt: Schnarchen und Verkehr sitzen tief. */
        var a = Math.floor(Math.pow(44, i / n)), b = Math.max(a + 1, Math.floor(Math.pow(44, (i + 1) / n)));
        var s = 0, c = 0;
        for (var j = a; j < b && j < daten.length; j++) { s += daten[j]; c++; }
        var v = c ? s / c / 255 : 0;
        bars[i].style.transform = 'scaleY(' + (0.06 + 0.94 * Math.pow(v, 1.5)).toFixed(3) + ')';
      }
      raf = requestAnimationFrame(malen);
    };
    var starteQuelle = function () {
      var alt = quelleNode;
      quelleNode = ctx.createBufferSource();
      quelleNode.buffer = puff(quelle);
      quelleNode.loop = true;
      quelleNode.connect(filt);
      quelleNode.start();
      if (alt) { try { alt.stop(ctx.currentTime + 0.05); } catch (e) { /* schon aus */ } }
    };
    var stop = function () {
      if (!laeuft) { return; }
      laeuft = false;
      pegel(0.05);
      var q = quelleNode; quelleNode = null;
      setTimeout(function () { try { if (q) { q.stop(); } } catch (e) { /* schon aus */ } }, 300);
      play.setAttribute('aria-pressed', 'false');
      playT.textContent = 'Abspielen';
      clearTimeout(stopT);
      cancelAnimationFrame(raf);
      demo.classList.remove('tipp');
      ruhe();
    };
    var start = function () {
      if (!AC) { return; }
      if (!ctx) { aufbauen(); }
      try { if (navigator.audioSession) { navigator.audioSession.type = 'playback'; } } catch (e) { /* nur Safari */ }
      if (ctx.state === 'suspended') { ctx.resume(); }
      laeuft = true;
      starteQuelle();
      pegel(0.08);
      play.setAttribute('aria-pressed', 'true');
      playT.textContent = 'Pause';
      clearTimeout(stopT);
      stopT = setTimeout(stop, 45000);
      malen();
      if (!tippGezeigt && !schalter.checked) {
        tippGezeigt = true;
        setTimeout(function () { if (laeuft && !schalter.checked) { demo.classList.add('tipp'); } }, 2600);
      }
    };

    play.addEventListener('click', function () { if (laeuft) { stop(); } else { start(); } });
    schalter.addEventListener('change', function () {
      demo.classList.toggle('gedaempft', schalter.checked);
      demo.classList.remove('tipp');
      if (laeuft) { pegel(0.12); } else if (schalter.checked) { start(); }
    });
    $$('.demo__quelle button', demo).forEach(function (b) {
      b.addEventListener('click', function () {
        quelle = b.dataset.quelle;
        $$('.demo__quelle button', demo).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        if (laeuft) { starteQuelle(); pegel(0.08); } else { start(); }
      });
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { if (!es[0].isIntersecting) { stop(); } }, { threshold: 0.15 }).observe(demo);
    }
  }

  /* --------------------------------------------------------
     4 — Schlaf-Check
     ------------------------------------------------------------
     Die Empfehlung hängt wirklich an den Antworten. Zu zweit oder
     Lärm → das Set (mit Geschenk, solange die Aktion läuft). Allein
     und nur Licht → EINE Maske, mit dem Hinweis auf das Set. Erst
     die eigene Nacht in eigenen Worten, dann die Empfehlung.
     -------------------------------------------------------- */
  var quiz = $('#quiz');
  if (quiz) {
    var fragen = $$('.quiz__frage', quiz), buehne = $('.quiz__buehne', quiz), punkte = $$('.quiz__punkte i', quiz);
    var erg = $('#quiz-ergebnis'), antw = [], echos = [], schritt = 0, gesperrt = false;
    var HAKEN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12l6 6L20 6"/></svg>';

    var hoehe = function () {
      var max = 0;
      fragen.forEach(function (f) {
        var war = f.classList.contains('an');
        f.classList.add('an');
        max = Math.max(max, f.offsetHeight);
        if (!war) { f.classList.remove('an'); }
      });
      if (max > 0) { buehne.style.minHeight = max + 'px'; }
    };
    var zeige = function (i) {
      fragen.forEach(function (f, n) { f.classList.toggle('an', n === i); f.classList.toggle('raus', n < i); });
      punkte.forEach(function (p, n) { p.classList.toggle('an', n <= i); });
    };
    var satz = function () {
      var s = echos.join(', ').replace(/, und /g, ' und ');
      return s.charAt(0).toUpperCase() + s.slice(1) + '.';
    };
    var auswerten = function () {
      var k = K(), euro = k.euro || function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
      var aktion = k.aktionLaeuft ? k.aktionLaeuft() : false;
      var zuzweit = antw[0] === 'zwei';
      var laerm = antw[1] === 'laerm' || antw[1] === 'beides';
      var licht = antw[1] === 'licht' || antw[1] === 'beides';
      var tier = zuzweit || (laerm && aktion) ? 'zwei' : 'eins';
      var gr = [];
      if (zuzweit) { gr.push('Eine Maske für jeden von euch – die Farben wählt ihr getrennt.'); }
      else if (tier === 'zwei') { gr.push('Die zweite Maske ist für Reise oder Wäsche – und nur im Set sind die Ohrstöpsel gratis.'); }
      if (laerm && aktion) { gr.push('Gegen Schnarchen und Straße: Die Ohrstöpsel sind im Set geschenkt.'); }
      if (licht) { gr.push('Die Kontur schließt an der Nase ab – kein Restlicht.'); }
      if (antw[2] === 'seite') { gr.push('Auf der Seite trägt der Wangenknochen, nicht das Auge.'); }
      if (antw[2] === 'ruecken') { gr.push('Über den Lidern bleibt Luft – kein Druck, auch nach Stunden.'); }
      if (antw[2] === 'wechsel') { gr.push('Das Klettband sitzt seitlich – nichts drückt unter dem Kopf.'); }
      gr = gr.slice(0, 3);

      var P = D.preise || {}, z = k.zustand ? k.zustand() : {}, nm = k.name || function (x) { return x; };
      var titel = tier === 'zwei'
        ? (zuzweit ? 'Euer Set: 2 Masken' : 'Dein Set: 2 Masken') + (aktion ? ' + Ohrstöpsel geschenkt' : '')
        : 'Für dich: 1 Maske';
      var alt = tier === 'zwei' && aktion && P.wert > 0 ? '<s>' + euro(P.wert) + '</s>' : '';
      var farben = tier === 'zwei' ? nm(z.m1) + ' + ' + nm(z.m2) : nm(z.m1);
      var knopf = tier === 'zwei' ? (aktion ? '2 Masken + Geschenk sichern' : '2 Masken in den Warenkorb') : 'In den Warenkorb';

      buehne.hidden = true;
      erg.innerHTML =
        '<p class="quiz__eyebrow">Deine Nacht</p><p class="quiz__echo">' + satz() + '</p>' +
        '<p class="quiz__eyebrow">Unsere Empfehlung</p><p class="quiz__name">' + titel + '</p>' +
        '<ul class="quiz__gruende">' + gr.map(function (g) { return '<li>' + HAKEN + '<span>' + g + '</span></li>'; }).join('') + '</ul>' +
        '<p class="quiz__preis"><b>' + euro(tier === 'zwei' ? P.zwei : P.eins) + '</b>' + alt + '</p>' +
        '<button class="btn btn--kauf btn--voll" type="button" data-q-kauf="' + tier + '">' + knopf + '</button>' +
        '<p class="quiz__farben">Farbe: ' + farben + ' · <button class="quiz__link" type="button" data-q-farbe>ändern</button></p>' +
        (tier === 'eins' && aktion
          ? '<p class="quiz__tipp">Tipp: Im 2er-Set sind die Ohrstöpsel geschenkt. <button class="quiz__link" type="button" data-q-kauf="zwei">Lieber das Set</button></p>'
          : '') +
        '<button class="quiz__neu" type="button" data-q-neu>Noch mal von vorn</button>';
      erg.hidden = false;
      erg.classList.remove('rein'); void erg.offsetWidth; erg.classList.add('rein');
      punkte.forEach(function (p) { p.classList.add('an'); });
    };

    quiz.addEventListener('click', function (ev) {
      var b = ev.target.closest('button');
      if (!b) { return; }
      var k = K();
      if (b.dataset.qKauf) {
        if (k.tierSetzen) { k.tierSetzen(b.dataset.qKauf); }
        if (k.inKorb) { k.inKorb(b.dataset.qKauf, b); }
        return;
      }
      if (b.hasAttribute('data-q-farbe')) {
        var ziel = $('#opts');
        if (ziel) { ziel.scrollIntoView({ behavior: leise ? 'auto' : 'smooth', block: 'center' }); }
        return;
      }
      if (b.hasAttribute('data-q-neu')) {
        antw = []; echos = []; schritt = 0; gesperrt = false;
        erg.hidden = true; erg.innerHTML = '';
        buehne.hidden = false;
        fragen.forEach(function (f) { f.classList.remove('raus'); });
        zeige(0);
        return;
      }
      if (!b.closest('.quiz__opt') || gesperrt) { return; }
      gesperrt = true;
      b.classList.add('gewaehlt');
      antw[schritt] = b.dataset.k;
      if (b.dataset.echo) { echos.push(b.dataset.echo); }
      setTimeout(function () {
        b.classList.remove('gewaehlt');
        schritt += 1;
        gesperrt = false;
        if (schritt >= fragen.length) { auswerten(); } else { zeige(schritt); }
      }, leise ? 0 : 220);
    });
    hoehe();
    zeige(0);
    window.addEventListener('load', hoehe);
    window.addEventListener('resize', hoehe);
  }

  /* --------------------------------------------------------
     5 — Punkte unter dem Bewertungs-Karussell (nur am Handy).
         Das Wischen selbst macht der Browser (scroll-snap).
     -------------------------------------------------------- */
  var revs = $('#revs'), revdots = $('#revdots');
  if (revs && revdots) {
    var karten = Array.prototype.slice.call(revs.children);
    if (karten.length > 1) {
      revdots.hidden = false;
      revdots.removeAttribute('aria-hidden');
      karten.forEach(function (karte, i) {
        var p = document.createElement('button');
        p.type = 'button';
        p.setAttribute('aria-label', 'Zu Bewertung ' + (i + 1));
        if (i === 0) { p.className = 'an'; }
        p.addEventListener('click', function () {
          var ziel = (karte.offsetLeft - revs.offsetLeft) - (revs.clientWidth - karte.offsetWidth) / 2;
          revs.scrollTo({ left: Math.max(0, ziel), behavior: leise ? 'auto' : 'smooth' });
        });
        revdots.appendChild(p);
      });
      var rp = Array.prototype.slice.call(revdots.children), rt = false;
      revs.addEventListener('scroll', function () {
        if (rt) { return; }
        rt = true;
        requestAnimationFrame(function () {
          rt = false;
          var mitte = revs.scrollLeft + revs.clientWidth / 2, beste = 0, min = Infinity;
          karten.forEach(function (k, i) {
            var a = Math.abs((k.offsetLeft - revs.offsetLeft) + k.offsetWidth / 2 - mitte);
            if (a < min) { min = a; beste = i; }
          });
          rp.forEach(function (p, i) { p.classList.toggle('an', i === beste); });
        });
      }, { passive: true });
    }
  }
})();
